import React from "react";

import Layout from "@components/layout";
import CountriesTemplate from "@components/countriesPage/countriesTemplate";

const IndexPage = ({ pageContext }) => (
  <Layout locale={pageContext.locale}>
    <CountriesTemplate pageContext={pageContext} />
  </Layout>
);

export default IndexPage;
